import { useState } from 'react';

export function usePluginDialogFocus() {
  const [target] = useState(() =>
    document.activeElement instanceof HTMLElement ? document.activeElement : null,
  );
  return (event: Event) => {
    if (!target?.isConnected) return;
    event.preventDefault();
    target.focus();
  };
}
